import { render } from "./Index.vue?vue&type=template&id=1f162a08&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=1f162a08&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=1f162a08&lang=scss"
script.render = render
script.__scopeId = "data-v-1f162a08"

export default script